// removed by extract-text-webpack-plugin
module.exports = {"overlay":"bag-warning__overlay___3Usj_","fadeOut":"bag-warning__fadeOut___HuJ9h","icon":"bag-warning__icon___2d6f3 globals__icon___2kiCi","bodyFixed":"bag-warning__bodyFixed___2o-fP","section":"bag-warning__section___II1Q_","btnClose":"bag-warning__btnClose___2qkyC globals__btn___2fgn7","btnPrimary":"bag-warning__btnPrimary___3olvd globals__btn___2fgn7","btnAccent":"bag-warning__btnAccent___15o5n globals__btn___2fgn7","link":"bag-warning__link___f8YYg globals__link___3RT55","flexRow":"bag-warning__flexRow___1ph_0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/bag-warning/bag-warning.scss
// module id = 519
// module chunks = 0